"use client"

import { useEffect } from "react"
import { Center, Stack, Title, Alert, Button } from "@forestsync/ui"
import { TbAlertCircle, TbRefresh } from "react-icons/tb"
import { useTranslations } from "next-intl"

interface ErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function Error({ error, reset }: ErrorProps) {
  const t = useTranslations("errors")

  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <Center h="100vh">
      <Stack align="center" gap="md" maw={480} ta="center">
        <Alert
          icon={<TbAlertCircle size={20} />}
          color="red"
          variant="light"
          w="100%"
          title={t("somethingWentWrong")}
        >
          {process.env.NODE_ENV === "development" ? error.message : t("somethingWentWrong")}
        </Alert>
        <Title order={3}>{t("somethingWentWrong")}</Title>
        <Button
          variant="filled"
          leftSection={<TbRefresh size={16} />}
          onClick={reset}
        >
          {t("tryAgain")}
        </Button>
      </Stack>
    </Center>
  )
}
